import React, { useState, useContext, useEffect } from "react";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  ContentBlock,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import {
    PAConnectorCard,
    PAconnectorGTM,
    PAconnectorGA,
    PAconnectorFB,
    PAconnectorPN,
    PAconnectorTW,
    PAconnectorForum,
    PAconnectorMCH,
    PAconnectorZapier,
    PAconnectorWH,
    PAconnectorInv,
    PAconnectorChatSlack,
    PAconnectorXsollaDigest,
} from './PAconnectors';

import merge from "deepmerge";
import { ContextConsumer, GlobalContext } from './PA';
import { IntlProvider } from "react-intl";
import PAContentBlock from "./PAContentBlock";
import { Link } from "react-router-dom";
import { CardTodo, CardSite } from "./PAcardNew";
import PAwebhooks from "./PAwebhooks";


import {
  // PAchart1,
  PAchart2
  // PAchartMap
} from "./PAchart2";


export default function PAallConnectors() {
  return (
    <div>

      <FormGroup indentation="lg">
        <ContentBlock indentation="lg">
          <Head appearance="separated" indentation="xlg">
            Global
          </Head>

          <FormGroup indentation="lg">
            <PAContentBlock title="Apps" border={false}>


            <FormGroup indentation="md">

              <div
                style={{
                  display: "grid",
                  // gridTemplateColumns: "repeat(2, 48%)",
                  gridColumnGap: "4%",
                  gridRowGap: "16px"
                }}
              >
                <div className="">
                  <FormGroup indentation="lg">
                    <PAconnectorChatSlack>
                      Add Xsolla chat to manage orders, request support, and get product updates. Choose the desired Xsolla channels to connect to your current chat platform.
                    </PAconnectorChatSlack>
                  </FormGroup>
                  <FormGroup>
                    <Button appearance='flatten' ><Icon name='add'/>Add another Slack connection</Button>
                  </FormGroup>
                  <br/>
                  <br/>
                  <FormGroup indentation="lg">
                    <PAconnectorXsollaDigest>
                      {/* Add Xsolla chat to manage orders, request support, and get product updates. Choose the desired Xsolla channels to connect to your current chat platform. */}
                    </PAconnectorXsollaDigest>
                  </FormGroup>
                </div>


              </div>
            </FormGroup>




            </PAContentBlock>
          </FormGroup>
        </ContentBlock>
      </FormGroup>



      <FormGroup indentation="lg">
        <ContentBlock indentation="lg">
          <Head appearance="separated" indentation="xlg">
            Store
          </Head>

          <FormGroup indentation="lg">
            <PAContentBlock title="Apps" border={false}>


            <FormGroup indentation="md">

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 48%)",
                  gridColumnGap: "4%",
                  gridRowGap: "16px"
                }}
              >
                {/* <FormGroup indentation="lg"> */}
                    <PAconnectorInv>
                      Single profile, trophies and unventory across PC and Xbox
                    </PAconnectorInv>
                {/* </FormGroup> */}

                {/* <FormGroup indentation="lg"> */}
                    <PAconnectorMCH>
                      Sync customers' emails with MailChimp
                    </PAconnectorMCH>
                {/* </FormGroup> */}


                {/* <FormGroup indentation="lg"> */}
                    <PAconnectorZapier>
                      Sync customers' data with any other service.
                    </PAconnectorZapier>
                {/* </FormGroup> */}

              </div>
            </FormGroup>

              <FormGroup indentation="lg">
                {/* <PAwebhooks
                  handleWebhooks={()=>{}}
                /> */}

                <PAconnectorWH>

                </PAconnectorWH>
              </FormGroup>



            </PAContentBlock>
          </FormGroup>
        </ContentBlock>
      </FormGroup>

      <FormGroup indentation="lg">
        <ContentBlock indentation="lg">
          <Head appearance="separated" indentation="xlg">
            Site Builder
          </Head>

          <PAContentBlock title="Apps" border={false}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 48%)",
                gridColumnGap: "4%",
                gridRowGap: "16px"
              }}
            >
              <PAconnectorGA>Tasks and reports website traffic</PAconnectorGA>

              <PAconnectorFB>
                Add the Facebook pixel to your website to measure the impact of
                your ads.
              </PAconnectorFB>

              <PAconnectorPN>
                <span>
                  Create and manage influencer programs and affiliate campaigns.{" "}
                  <a
                    href="https://developers.xsolla.com/doc/partner_network/"
                    target="_blank"
                  >
                    Learn more
                  </a>
                </span>
              </PAconnectorPN>

              <PAconnectorGTM>
                Manage JavaScript and HTML tags used to track your site's
                traffic.
              </PAconnectorGTM>

              <PAconnectorTW>
                Track the actions users take after viewing or engaging with your
                ads on Twitter.
              </PAconnectorTW>

              <PAconnectorForum>
                Build a community
              </PAconnectorForum>
            </div>
          </PAContentBlock>
        </ContentBlock>
      </FormGroup>

      <FormGroup indentation="lg">
        <ContentBlock indentation="lg">
          <Head appearance="separated" indentation="xlg">
            Pay Station
          </Head>

          <FormGroup indentation="lg">
            <PAContentBlock title="Apps" border={false}>

              <FormGroup indentation="lg">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 48%)",
                    gridColumnGap: "4%",
                    gridRowGap: "16px"
                  }}
                >
                  <PAconnectorGA>Tasks and reports website traffic</PAconnectorGA>

                  <PAconnectorFB>
                    Add the Facebook pixel to your website to measure the impact
                    of your ads.
                  </PAconnectorFB>
                </div>
              </FormGroup>

              <FormGroup indentation="lg">
                <PAwebhooks
                  handleWebhooks={()=>{}}
                />
              </FormGroup>

            </PAContentBlock>
          </FormGroup>
        </ContentBlock>
      </FormGroup>

      <FormGroup indentation="lg">
        <ContentBlock indentation="lg">
          <Head appearance="separated" indentation="xlg">
            Login
          </Head>

          <FormGroup indentation="lg">
            <PAContentBlock title="Apps" border={false}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 48%)",
                  gridColumnGap: "4%",
                  gridRowGap: "16px"
                }}
              >
                <PAconnectorMCH>Sync login users with MailChimp</PAconnectorMCH>
              </div>
            </PAContentBlock>
          </FormGroup>
        </ContentBlock>
      </FormGroup>
    </div>
  );
}
